module.exports = __webpack_public_path__ + "img/logo-akurata.lk.3fe7393e.svg";